module.exports = __webpack_public_path__ + "img/vietnam-CockFight.67afdd37.png";